// test
export { getUsers } from "./modules/Test";

//SingInSingUp
export {
  CheckEmail,
  VerifyEmail,
  Login,
  UpdateMemberInfo,
  ContactInfoUpdate,
  GetContInfoForm,
  GetAuthURL,
  SaveUserLocation,
  UnsubscribeEmail,
  ChangePassword,
  VerifyEmailForResetPassword,
  GetMyProfileData,
  AccountSettingsSave,
  ResetPassword,
  EmployerSignUp1,
  GetExperienceForm,
  ChangeInfo,
  GetEducationForm,
  EducationOperation,
  GetBasicInfoForm,
  SaveBasicInfo,
  EmployerSignUp2,
  SaveLanguages,
  OnSearchSkill,
  SaveSkills,
  GetCertificateForm,
  CertificateOperation
} from "./modules/User";

//jobs
export {
  GetJobTitles,
  GetJobLocations,
  GetJobRoleDepartments,
  SearchJobs,
  GetJobInfo,
  GetMyJobs,
  ApplyJob,
  FavoriteJob,
  getApplyJobForm,
  ApplyFormSave,
  GetMemberJobInfo,
  AddEmail,
  ChangeInterviewStatus,
  ChangeOfferStatus,
} from "./modules/Jobs";

//companies
export {
  SearchCompanies,
  GetCompanyInfo,
  AddCompanyReview,
  FavoriteCompany,
  GetCompanyReview,
  GetCompanyJobs,
} from "./modules/Companies";

//share
export { ShareJobOnLinkedIn } from "./modules/Share";

// News
export { GetNewsInfo } from "./modules/News";

export { GetAIUsage } from "./modules/AIUsage";
